import { useRef, useEffect } from "react";
import { Separator } from "@/components/ui/separator";

// Liste des entreprises de confiance pour la bannière de logos
const trustedCompanies = [{
  id: 1, name: "Google", logo: "/lovable-uploads/google-logo.webp", scale: 1.0
}, {
  id: 2, name: "J.P. Morgan", logo: "https://images.ctfassets.net/lr0atmu04u9z/1HeA8aR6UEoAX9GMwv8L1q/4dcc8bb4c826a5a176f66862f50f1065/jpmorgan.png", scale: 1.0
}, {
  id: 3, name: "Coca Cola", logo: "/lovable-uploads/coca-cola-logo.png", scale: 0.95
}, {
  id: 5, name: "Ikea", logo: "/lovable-uploads/ikea-logo.png", scale: 0.9
}, {
  id: 6, name: "L'Oréal", logo: "/lovable-uploads/loreal-logo.png", scale: 1.0
}, {
  id: 15, name: "Pfizer", logo: "/lovable-uploads/pfizer-logo.png", scale: 0.95
}, {
  id: 14, name: "Sanofi", logo: "/lovable-uploads/sanofi-logo.png", scale: 0.95
}, {
  id: 16, name: "Siemens Healthineers", logo: "/lovable-uploads/siemens-healthineers-logo.png", scale: 1.0
}, {
  id: 7, name: "Amazon", logo: "/lovable-uploads/amazon-logo.png", scale: 0.95
}, {
  id: 8, name: "BCG", logo: "https://cdn.prod.website-files.com/62efb8f03d1cea895120b9db/63da87abd9c70b3560d4c93d_BCG_MONOGRAM.png", scale: 0.85
}, {
  id: 9, name: "Chanel", logo: "https://upload.wikimedia.org/wikipedia/fr/3/34/Chanel_logo_complet.png", scale: 0.9
}, {
  id: 10, name: "Uber", logo: "/lovable-uploads/uber-logo.png", scale: 0.95
}, {
  id: 11, name: "Nestlé", logo: "/lovable-uploads/nestle-logo.png", scale: 0.95
}, {
  id: 12, name: "Figma", logo: "/lovable-uploads/figma-logo.webp", scale: 0.8
}];
interface LogoBannerProps {
  hideTitle?: boolean;
  hideSeparators?: boolean;
}
const LogoBanner = ({
  hideTitle = false,
  hideSeparators = false
}: LogoBannerProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    // Clone the logos first to ensure continuous scrolling
    const originalContent = scrollContainer.innerHTML;
    scrollContainer.innerHTML = originalContent + originalContent;

    // Use a fixed duration that works well on all devices
    // Based on number of logos, not content width (avoids layout calculation issues)
    const numberOfLogos = trustedCompanies.length * 2; // doubled content
    const secondsPerLogo = 1.5; // Time to scroll past one logo
    const animationDuration = numberOfLogos * secondsPerLogo;
    scrollContainer.style.animation = `scroll ${animationDuration}s linear infinite`;
    return () => {
      if (scrollContainer) {
        scrollContainer.innerHTML = originalContent;
      }
    };
  }, []);
  return <section className="bg-white overflow-hidden pb-0 h-auto flex flex-col justify-center">
      {!hideSeparators && <Separator />}
      
      <div className="w-full px-0 sm:px-0 flex-grow flex flex-col justify-center py-8">
        {!hideTitle && <h2 className="text-center text-lg font-normal text-gray-600 mb-6">Plus de 500M€ d'achats événementiels optimisés par Naboo</h2>}
        
        <div className="relative w-full overflow-hidden">
          <div ref={scrollContainerRef} className="flex items-center gap-8 sm:gap-12" style={{
          whiteSpace: 'nowrap',
          width: 'max-content'
        }}>
            {trustedCompanies.map(company => {
            return <div key={company.id} className="flex-shrink-0">
              <img src={company.logo} alt={`${company.name} logo`} loading="lazy" width="120" height="40" className="h-8 sm:h-10 w-auto object-contain transition-all duration-300 hover:scale-105" style={{
                maxHeight: "40px",
                maxWidth: "120px",
                transform: `scale(${company.scale ?? 1})`
              }} />
                </div>;
          })}
          </div>
        </div>
      </div>
      
      {!hideSeparators && <Separator />}
    </section>;
};
export default LogoBanner;